var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.app.loading),expression:"$store.state.app.loading"}],staticClass:"loading"},[_c('Loading',{attrs:{"color":"#1989fa"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }